import {
  Box,
  Checkbox,
  ListItemText,
  OutlinedInput,
  ThemeProvider,
  Typography,
  createTheme,
} from "@mui/material";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import * as React from "react";
import returnCityNames from "../asset/js/CityNames";
import { professions } from "../asset/js/Professions";

export default function DropDown({ setFilter, filter }) {
  const [personName, setPersonName] = React.useState(["הכל​"]);
  const cityNames = returnCityNames();
  const handleChange1 = (event) => {
    const {
      target: { value },
    } = event;
    setPersonName(
      // On autofill we get a stringified value.
      typeof value === "string" ? value.split(",") : value
    );
    setFilter({ area: event.target.value, profession: filter.profession });
  };
  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      },
    },
  };
  const handleChange = (event) => {
    event.preventDefault();
    if (event.target.name === "area") {
      setFilter({ area: event.target.value, profession: filter.profession });
    } else
      setFilter({
        profession: event.target.value,
        area: filter.area,
      });
  };
  const theme = createTheme({
    typography: {
      fontFamily: [
        "Assistant",
        "BlinkMacSystemFont",
        '"Segoe UI"',
        "Roboto",
        '"Helvetica Neue"',
        "Arial",
        "sans-serif",
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"',
      ].join(","),
    },
  });
  return (
    <div
      className="bidit-home-filters"
      style={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
      }}
    >
      <ThemeProvider theme={theme}>
        <Box
          sx={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: { xs: "stretch", md: "flex-start" },
            gap: 0.75,
            px: { xs: 1, md: 0 },
          }}
        >
          <Box className="bidit-filter-heading">
            <Typography className="bidit-filter-heading-title">
              סינון מכרזים
            </Typography>
            <Typography className="bidit-filter-heading-subtitle">
              בחר אזור ומקצוע להצגת מכרזים מתאימים
            </Typography>
          </Box>

          <Box
            sx={{
              width: "100%",
              display: "flex",
              alignItems: "flex-end",
              justifyContent: { xs: "space-between", md: "flex-start" },
              flexWrap: "nowrap",
              gap: { xs: 1, md: 1.25 },
            }}
          >
          <Box className="bidit-filter-field">
            <Typography className="bidit-filter-field-label">
              סינון לפי אזור
            </Typography>
        <FormControl
          required
          sx={{
            fontFamily: `${process.env.REACT_APP_FONT}`,
            m: 0,
            p: 0,
            width: { xs: "100%", sm: 170, md: 150 },
            minWidth: 0,
            flex: "0 0 auto",
          }}
        >
          <InputLabel
            sx={{
              fontFamily: `${process.env.REACT_APP_FONT}`,
              color: "#536b7e",
              fontSize: { xs: "0.82rem", md: "0.9rem" },
              "&.Mui-focused": { color: "#2f8ed8" },
            }}
            id="demo-simple-select-readonly-label"
          >
            בחר אזור
          </InputLabel>
          <Select
            sx={{
              fontFamily: `${process.env.REACT_APP_FONT}`,
              width: "100%",
              height: { xs: 40, md: 42 },
              borderRadius: "11px",
              backgroundColor: "#fff",
              boxShadow: "0 2px 8px rgba(24, 72, 119, 0.045)",
              "& .MuiOutlinedInput-notchedOutline": {
                borderColor: "#dce5ed",
              },
              "&:hover .MuiOutlinedInput-notchedOutline": {
                borderColor: "#a9bfd1",
              },
              "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                borderColor: "#2f8ed8",
                borderWidth: "1.5px",
              },
              "& .MuiSelect-select": {
                py: 1,
                pr: "30px !important",
                pl: 1.25,
                fontSize: { xs: "0.82rem", md: "0.9rem" },
                fontWeight: 600,
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              },
              "& .MuiSvgIcon-root": {
                color: "#6d8498",
                fontSize: 20,
              },
            }}
            labelId="demo-multiple-checkbox-label"
            id="demo-multiple-checkbox"
            placeholder="Enter Area"
            value={personName}
            onChange={handleChange1}
            input={<OutlinedInput label="בחר אזור" />}
            renderValue={(selected) => selected.join(", ")}
            MenuProps={MenuProps}
          >
            {[
              "הכל​",
              "צפון",
              "קרית שמונה והסביבה",
              "חיפה והסביבה",
              "ירושלים והסביבה",
              "נתניה והסביבה",
              "השרון והסביבה",
              "מרכז",
              "שפלה והסביבה",
              "באר שבע והסביבה",
              "דרום",
            ].map((name, i) => (
              <MenuItem
                key={name}
                value={name}
                sx={{
                  fontFamily: `${process.env.REACT_APP_FONT}`,
                  flexDirection: "column",
                  fontSize: { xs: "80%", md: "100%" },
                }}
              >
                <Checkbox checked={personName.indexOf(name) > -1} />
                <ListItemText primary={name} />
                <Box
                  display="block"
                  sx={{ fontFamily: `${process.env.REACT_APP_FONT}` }}
                >
                  {name === "צפון" ? (
                    <Box>
                      {cityNames.southCities.map((e) => {
                        return (
                          <Typography
                            variant="p"
                            display="block"
                            sx={{
                              fontFamily: `${process.env.REACT_APP_FONT}`,
                              color: "grey",
                              margin: "0px 3px",
                            }}
                          >
                            {e}
                          </Typography>
                        );
                      })}
                    </Box>
                  ) : name === "קרית שמונה והסביבה" ? (
                    <Box>
                      {cityNames.northCities.map((e) => {
                        return (
                          <Typography
                            variant="p"
                            display="block"
                            sx={{
                              fontFamily: `${process.env.REACT_APP_FONT}`,
                              color: "grey",
                              margin: "0px 3px",
                            }}
                          >
                            {e}
                          </Typography>
                        );
                      })}
                    </Box>
                  ) : name === "חיפה והסביבה" ? (
                    <Box>
                      {cityNames.westCities.map((e) => {
                        return (
                          <Typography
                            variant="p"
                            display="block"
                            sx={{
                              fontFamily: `${process.env.REACT_APP_FONT}`,
                              color: "grey",
                              margin: "0px 3px",
                            }}
                          >
                            {e}
                          </Typography>
                        );
                      })}
                    </Box>
                  ) : name === "ירושלים והסביבה" ? (
                    <Box>
                      {cityNames.eastCities.map((e) => {
                        return (
                          <Typography
                            variant="p"
                            display="block"
                            sx={{
                              fontFamily: `${process.env.REACT_APP_FONT}`,
                              color: "grey",
                              margin: "0px 3px",
                            }}
                          >
                            {e}
                          </Typography>
                        );
                      })}
                    </Box>
                  ) : name === "נתניה והסביבה" ? (
                    <Box>
                      {cityNames.eCities.map((e) => {
                        return (
                          <Typography
                            variant="p"
                            display="block"
                            sx={{
                              fontFamily: `${process.env.REACT_APP_FONT}`,
                              color: "grey",
                              margin: "0px 3px",
                            }}
                          >
                            {e}
                          </Typography>
                        );
                      })}
                    </Box>
                  ) : name === "השרון והסביבה" ? (
                    <Box>
                      {cityNames.fCities.map((e) => {
                        return (
                          <Typography
                            variant="p"
                            display="block"
                            sx={{
                              fontFamily: `${process.env.REACT_APP_FONT}`,
                              color: "grey",
                              margin: "0px 3px",
                            }}
                          >
                            {e}
                          </Typography>
                        );
                      })}
                    </Box>
                  ) : name === "מרכז" ? (
                    <Box>
                      {cityNames.gCities.map((e) => {
                        return (
                          <Typography
                            variant="p"
                            display="block"
                            sx={{
                              fontFamily: `${process.env.REACT_APP_FONT}`,
                              color: "grey",
                              margin: "0px 3px",
                            }}
                          >
                            {e}
                          </Typography>
                        );
                      })}
                    </Box>
                  ) : name === "שפלה והסביבה" ? (
                    <Box>
                      {cityNames.hCities.map((e) => {
                        return (
                          <Typography
                            variant="p"
                            display="block"
                            sx={{
                              fontFamily: `${process.env.REACT_APP_FONT}`,
                              color: "grey",
                              margin: "0px 3px",
                            }}
                          >
                            {e}
                          </Typography>
                        );
                      })}
                    </Box>
                  ) : name === "באר שבע והסביבה" ? (
                    <Box>
                      {cityNames.iCities.map((e) => {
                        return (
                          <Typography
                            variant="p"
                            display="block"
                            sx={{
                              fontFamily: `${process.env.REACT_APP_FONT}`,
                              color: "grey",
                              margin: "0px 3px",
                            }}
                          >
                            {e}
                          </Typography>
                        );
                      })}
                    </Box>
                  ) : name === "דרום" ? (
                    <Box>
                      {cityNames.jCities.map((e) => {
                        return (
                          <Typography
                            variant="p"
                            display="block"
                            sx={{
                              fontFamily: `${process.env.REACT_APP_FONT}`,
                              color: "grey",
                              margin: "0px 3px",
                            }}
                          >
                            {e}
                          </Typography>
                        );
                      })}
                    </Box>
                  ) : (
                    ""
                  )}
                </Box>
              </MenuItem>
            ))}
          </Select>
        </FormControl>
          </Box>
          <Box className="bidit-filter-field">
            <Typography className="bidit-filter-field-label">
              סינון לפי מקצוע
            </Typography>
        <FormControl
          required
          sx={{
            fontFamily: `${process.env.REACT_APP_FONT}`,
            m: 0,
            width: { xs: "100%", sm: 190, md: 175 },
            minWidth: 0,
            flex: "0 0 auto",
          }}
        >
          <InputLabel
            sx={{
              color: "#536b7e",
              fontFamily: `${process.env.REACT_APP_FONT}`,
              fontSize: { xs: "0.82rem", md: "0.9rem" },
              "&.Mui-focused": { color: "#2f8ed8" },
            }}
            id="demo-simple-select-required-label"
          >
            בחר מקצוע
          </InputLabel>
          <Select
            labelId="demo-simple-select-required-label"
            id="demo-simple-select-required"
            value={filter.profession}
            label="בחר מקצוע"
            name="profession"
            sx={{
              fontFamily: `${process.env.REACT_APP_FONT}`,
              width: "100%",
              height: { xs: 40, md: 42 },
              borderRadius: "11px",
              backgroundColor: "#fff",
              boxShadow: "0 2px 8px rgba(24, 72, 119, 0.045)",
              "& .MuiOutlinedInput-notchedOutline": {
                borderColor: "#dce5ed",
              },
              "&:hover .MuiOutlinedInput-notchedOutline": {
                borderColor: "#a9bfd1",
              },
              "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                borderColor: "#2f8ed8",
                borderWidth: "1.5px",
              },
              "& .MuiSelect-select": {
                py: 1,
                pr: "30px !important",
                pl: 1.25,
                fontSize: { xs: "0.82rem", md: "0.9rem" },
                fontWeight: 600,
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              },
              "& .MuiSvgIcon-root": {
                color: "#6d8498",
                fontSize: 20,
              },
            }}
            onChange={handleChange}
          >
            <MenuItem
              value="הכל​"
              sx={{ fontFamily: `${process.env.REACT_APP_FONT}` }}
            >
              הכל​
            </MenuItem>
            {professions.map((e) => (
              <MenuItem
                sx={{ fontFamily: `${process.env.REACT_APP_FONT}` }}
                value={e}
              >
                {e}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
          </Box>
          </Box>
        </Box>
      </ThemeProvider>
    </div>
  );
}
